import AnalyticsEvents_V2 from '../analyticsGA4'
import { PortalProducts } from '../types/analytics.type'

import { StatisticsEvents } from './statisticsEvents.types'

class StatisticsAnalytics extends AnalyticsEvents_V2 {
  public constructor() {
    super(PortalProducts.SCOREBOARD)
  }

  public logProductCardToggle({ cardName, expanded }: { cardName: string; expanded: boolean }): void {
    this.logEvent({
      event: expanded ? StatisticsEvents.EXPAND_PRODUCT_CARD : StatisticsEvents.COLLAPSE_PRODUCT_CARD,
      card_name: cardName,
    })
  }

  public logProductTileClick({ title }: { title: string }): void {
    this.logEvent({
      event: StatisticsEvents.PRODUCT_TITLE_CLICKED,
      title,
    })
  }

  public logTestprepRetakeButtonClick({ examID }: { examID: number }): void {
    this.logEvent({
      event: StatisticsEvents.CLICK_RETAKE_BUTTON,
      title: `Test prep ExamID: ${examID}`,
      examId: examID,
    })
  }

  public logRetakeButtonClick({ name, setNumber }: { name: string; setNumber: number }): void {
    this.logEvent({
      event: StatisticsEvents.CLICK_RETAKE_BUTTON,
      title: `Title: ${name} Activity set: ${setNumber}`,
      activity_set: setNumber,
    })
  }
}

export default new StatisticsAnalytics()
